import { MemberSelectionRequest } from 'src/modules/member/models/memberSelectionRequest';
import { Selection } from 'src/modules/groupMessageEmail/models/selection';
import { SelectionPutRequest } from 'src/modules/member/models/selectionPutRequest';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'Selection';

type PagingParams = {
  jsonDataRequired: boolean;
  pageIndex: number;
  pageSize: number;
  sortCol: string;
  sortDir: string;
  filter?: string;
};

function pagingParams({ jsonDataRequired, pageIndex, pageSize, sortCol, sortDir, filter }: PagingParams) {
  let result = `jsonDataRequired=${jsonDataRequired}`;
  result += `&pageIndex=${pageIndex}`;
  result += pageSize && `&pageSize=${pageSize}`;
  result += sortCol && `&sortCol=${sortCol}`;
  result += sortDir && `&sortDir=${sortDir}`;
  result += filter ? `&filter=${encodeURIComponent(filter)}` : '';
  return result;
}

export const getSelections = (jsonDataRequired, pageIndex, pageSize, sortCol, sortDir, filter?: string) => {
  const endpoint = `${controller}/?${pagingParams({ jsonDataRequired, pageIndex, pageSize, sortCol, sortDir, filter })}`;
  return AxiosInstance.get<PagedResult<Selection>>(endpoint);
};

export const getSelectionById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<Selection>(endpoint);
};

export const postSelection = (selection: MemberSelectionRequest) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<MemberSelectionRequest>(endpoint, selection);
};

export const updateSelection = (selection: SelectionPutRequest) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<MemberSelectionRequest>(endpoint, selection);
};

export const deleteSelection = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
